import { StrictFetch } from "./utils/client/base.js";
import { defineNuxtPlugin } from "#app";
export default defineNuxtPlugin(() => {
  StrictFetch.autoInit?.();
});
